import { render } from "./BillingPlan.vue?vue&type=template&id=cee7d83a&scoped=true"
import script from "./BillingPlan.vue?vue&type=script&lang=js"
export * from "./BillingPlan.vue?vue&type=script&lang=js"

import "./BillingPlan.vue?vue&type=style&index=0&id=cee7d83a&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cee7d83a"]])

export default __exports__